import { IOrderTagData } from '../../../types/order/tags/IOrderTagData';
import { ENGLISH_ABBREVIATION } from '../../labelComparator';

export const sortTagsAlphabeticallyByType = ({ tag: tagA }: IOrderTagData, { tag: tagB }: IOrderTagData) => {
  // ensure 'escalation' tags are shown first
  if (tagA.type === 'escalation' && tagB.type !== 'escalation') {
    return -1;
  } else if (tagA.type !== 'escalation' && tagB.type === 'escalation') {
    return 1;
  }

  // sort alphabetically by 'tagId'
  return tagA.label.localeCompare(tagB.label, ENGLISH_ABBREVIATION, { sensitivity: 'base' });
};
